import { ActionType } from '../constants/ActionTypes'

export default function businessRulesReducer(state = {}, action = {}) {
    switch (action.type) {
     
      
        case ActionType.GET_BUSINESS_RULES_BEGIN:
            return {
                ...state,
                data: [],
                isLoading: true,
                error: null
            }
        case ActionType.GET_BUSINESS_RULES_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case ActionType.GET_BUSINESS_RULES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload
            }
     
        default:
            return state;
    }
}

